import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from "primereact/tabview";
import DetailsForm from "./DetailsForm";
import AppointmentHistory from "./AppointmentHistory";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";
import Layout from "../../../Layout";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";

const DirectorDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const handleFetchData = async () => {
    const response = await apiService(API_ROUTES.FETCH_DIRECTOR, "GET", {
      replace: { id },
    });
    setData(response.data);
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <Layout
      crumbs={[
        { label: "My Entities", url: "/entities" },
        {
          label: (
            <>
              {data?.entityData?.name} (
              <ReactCountryFlag
                countryCode={data?.entityData?.country}
                svg
                className=""
              />{" "}
              {getName(data?.entityData?.country || "")})
            </>
          ),
          id: "entity",
          url: `/entity/${data?.entityData?.id}/dashboard`,
        },
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              Directors
            </span>
          ),
          id: "directors",
          command: () => navigate(-1),
        },
        { label: `${data.name} ${data.last_name}`, id: "director" },
      ]}
    >
      <div className="director-details">
        <div className="director-info mb-3">
          <div className="avatar-container mr-3">
            <h3>{getInitials(`${data.name} ${data.last_name}`)}</h3>
          </div>
          <div className="name-desc">
            <h4 className="mb-2">{`${data.name} ${data.last_name}`}</h4>
            <p className="flex align-items-center">
              {data?.positions ? (
                data?.positions
                  ?.filter((item) => item.status === "Active")
                  .map((item) => item.position)
                  .join(" / ")
              ) : (
                <Skeleton width="5rem" height="1.5rem" shape="rectangle" />
              )}{" "}
              at{" "}
              <Link
                className="link-item"
                to={`/entity/${data?.entityData?.id}/dashboard`}
              >
                {data?.entityData?.name}
              </Link>
            </p>
          </div>
        </div>
        <div className="card">
          <TabView>
            <TabPanel header="Details">
              <DetailsForm data={data} />
            </TabPanel>
            <TabPanel header="Appointment History">
              <AppointmentHistory historyData={data?.positions} />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </Layout>
  );
};

export default DirectorDetails;
